export default __webpack_public_path__ + "static/media/expo~ZuWnklkh.cae1489a.svg";